'use strict';

var _slicedToArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var debug = require('debug');
/**
 * Creates a logger for the given subsystem
 *
 * @param {PeerId} [id]
 * @param {string} [subsystem]
 * @returns {debug}
 *
 * @private
 */


var logger = function logger(id, subsystem) {
  var name = ['bitswap'];

  if (subsystem) {
    name.push(subsystem);
  }

  if (id) {
    name.push("".concat(id.toB58String().slice(0, 8)));
  }

  var logger = debug(name.join(':'));
  logger.error = debug(name.concat(['error']).join(':'));
  return logger;
};

var includesWith = function includesWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }

    idx += 1;
  }

  return false;
};

var uniqWith = function uniqWith(pred, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var item;

  while (idx < len) {
    item = list[idx];

    if (!includesWith(pred, item, result)) {
      result[result.length] = item;
    }

    idx += 1;
  }

  return result;
};

var groupBy = function groupBy(pred, list) {
  return list.reduce(function (acc, v) {
    var k = pred(v);

    if (acc[k]) {
      acc[k].push(v);
    } else {
      acc[k] = [v];
    }

    return acc;
  }, {});
};

var pullAllWith = function pullAllWith(pred, list, values) {
  return list.filter(function (i) {
    return !includesWith(pred, i, values);
  });
};

var sortBy = function sortBy(fn, list) {
  return Array.prototype.slice.call(list, 0).sort(function (a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  });
};
/**
 * Is equal for Maps of BitswapMessageEntry or Blocks
 * @param {Map} a
 * @param {Map} b
 * @returns {boolean}
 */


var isMapEqual = function isMapEqual(a, b) {
  if (a.size !== b.size) {
    return false;
  }

  var _iterator = _createForOfIteratorHelper(a),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          valueA = _step$value[1];

      if (!b.has(key)) {
        return false;
      }

      var valueB = b.get(key); // Support BitswapMessageEntry

      if (typeof valueA.equals === 'function' && !valueA.equals(valueB)) {
        return false;
      } // Support Blocks


      if (valueA._data && !valueA._data.equals(valueB._data)) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
};

module.exports = {
  logger: logger,
  includesWith: includesWith,
  uniqWith: uniqWith,
  groupBy: groupBy,
  pullAllWith: pullAllWith,
  sortBy: sortBy,
  isMapEqual: isMapEqual
};